import { render } from "./NewComing.vue?vue&type=template&id=36d8e84a"
import script from "./NewComing.vue?vue&type=script&lang=js"
export * from "./NewComing.vue?vue&type=script&lang=js"

import "./NewComing.vue?vue&type=style&index=0&id=36d8e84a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__